import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';

@Injectable({
  providedIn: 'root'
})
export class RegistorpatientService {

  constructor(private GenericUtility: GenericUtilityService) { }

  RegistorPatient(data: any) {
    return this.GenericUtility.ApiPostMethodTalkphr("TalkCheckinPhaseTwo", "PatientRegistration", data);
  }
  SendOTP(obj: any) {
    return this.GenericUtility.ApiPostMethodOTP('MultiFactorAuth', 'SendOTP', obj);
  }
  VerifyOTP(obj: any) {
    return this.GenericUtility.ApiPostMethodOTP('MultiFactorAuth', 'VerifyOTP', obj);
  }
  GetLocation(practice_code: any) {
    return this.GenericUtility.ApiGetMethodTalkphr('TalkCheckinPhaseTwo/GetLocation?PracticeCode=' + practice_code);
  }
  VerifyPracticeCode(practice_code: any) {
    return this.GenericUtility.ApiGetMethodTalkphr('TalkCheckinPhaseTwo/LinkVerification?PracticeCode=' + practice_code);
  }
}
